import { GridApiPro, GridPreferencePanelsValue } from '@mui/x-data-grid-pro';
import { MutableRefObject, useCallback } from 'react';

export interface UseDataGridPreferencePanelToggleOptions {
  panelId?: string;
  buttonId?: string;
}

export interface UseDataGridPreferencePanelToggleResult {
  isPanelOpen: () => boolean;
  onToggle: (wasOpenAtInteraction?: boolean) => void;
}

export function useDataGridPreferencePanelToggle(
  apiRef: MutableRefObject<GridApiPro | null>,
  panelValue: GridPreferencePanelsValue,
  options?: UseDataGridPreferencePanelToggleOptions
): UseDataGridPreferencePanelToggleResult {
  const { panelId, buttonId } = options ?? {};

  const isPanelOpen = useCallback((): boolean => {
    const preferencePanel = apiRef.current?.state?.preferencePanel;
    return (
      preferencePanel?.open === true &&
      preferencePanel?.openedPanelValue === panelValue
    );
  }, [apiRef, panelValue]);

  const onToggle = useCallback(
    (wasOpenAtInteraction?: boolean): void => {
      const api = apiRef.current;
      if (!api?.showPreferences) {
        return;
      }

      const isOpen =
        typeof wasOpenAtInteraction === 'boolean'
          ? wasOpenAtInteraction
          : isPanelOpen();

      if (isOpen) {
        api.hidePreferences?.();
        return;
      }

      api.showPreferences(panelValue, panelId, buttonId);
    },
    [apiRef, panelValue, panelId, buttonId, isPanelOpen]
  );

  return { isPanelOpen, onToggle };
}
